import React from 'react';
import BossDialog from '../../components/BossDialog';
import { ADS_TYPE} from '../../framework/constant/constant';
import IconSquareButton from '../../framework/forms/helpercomponents/buttons/IconSquareButton';

const SMChannelIconForm = ({ handleCancel, handleSelectedChannel }) => {

    const channelConfigs = [
        { type: ADS_TYPE.META, label: 'Meta', icon: 'fa fa-facebook', color: '#4267B2' },
        { type: ADS_TYPE.GOOGLE, label: 'Google', icon: 'fa fa-google', color: '#EA4335' },
        { type: ADS_TYPE.LINKEDIN, label: 'LinkedIn', icon: 'fa fa-linkedin', color: '#0077B5' },
        { type: ADS_TYPE.YOUTUBE, label: 'YouTube', icon: 'fa fa-youtube', color: '#FF0000' },
        { type: ADS_TYPE.SNAPCHAT, label: 'Snapchat', icon: 'fab fa-snapchat-ghost', color: '#FFFC00', textColor: '#000' },
    ];

    return (
        <BossDialog title="Social Media Channel Type" onClose={handleCancel} width="400px">
                <div style={{ display: 'grid', gridTemplateColumns: "1fr 1fr 1fr", gap: "8px" }}>
                    {channelConfigs.map((channel) => (
                        <IconSquareButton
                            key={channel.type}
                            name={channel.label}
                            title={channel.label}
                            width={'70px'}
                            height={'70px'}
                            borderRadius={'10px'}
                            icon={channel.icon}
                            iconSize={'36px'}
                            backgroundColor={channel.color}
                            color={channel.textColor || '#fff'}
                            onClick={() => handleSelectedChannel(channel.type)}
                        />
                    ))}
                </div>
        </BossDialog>
    );
};

export default SMChannelIconForm;




